import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ThumbUpAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"thumb_up_alt"}/>
}
